import * as React from "react";
import styled from "styled-components";
import { WMKGradient, colors } from "../../../vars/palette";
import { BlockTitleTextAndIconsRowFields } from "../../../fragments/blockTitleTextAndIconsRowFields";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import BlockIconCopy from "./BlockIconCopy";
import { Col, Container, Row } from "react-bootstrap";
import { WmkLink } from "wmk-link";
import Button from "../../common/GibsonButton";
import { Img, WmkImage } from "wmk-image";
// import BlockIconCopyButton from "./BlockIconCopyButton";

const Wrap = styled.div<{
  displayStyle: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ displayStyle }) =>
    displayStyle === "White, left aligned" ? "transparent" : "#332237"};
  padding: 3rem 1rem 2rem;
  font-family: "Nunito Sans";
  margin-left: var(--bs-gutter-x, -0.75rem);
  margin-right: var(--bs-gutter-x, -0.75rem);
  .light-display {
    justify-content: center;
  }

  ${({ displayStyle }) =>
    displayStyle === "White, left aligned"
      ? `
      h2 {
        font-weight: 800;
        color: ${colors.hex("text")};
        font-size: 35px;
        text-align: center;
      }
      h6 {
        color: ${colors.hex("secondary")};
      }
      // .icon-col {
      //   display: flex;
      //   justify-content: flex-end;
      // }
      .subsection-row {
        justify-content: center;
      }
    }`
      : `h2 {
          font-weight: 600;
          color: ${colors.hex("secondary")};
          font-size: 35px;
          text-align: center;
        }
        p {
          color: white !important;
          margin: 1rem 1rem 2rem;
          text-align: center;
          font-size: 18px !important;
          width: 80%;
        }
        `};

  .subtitle {
    color: ${colors.hex("secondary")};
    text-align: center;
    margin-bottom: 4rem;
  }
  .copyButton {
    display: inline-block;
    padding: 0.25rem 2.5rem;
    margin-top: 2rem;
    border: 2px solid ${colors.hex("secondary")};
    color: ${colors.hex("secondary")};
    text-decoration: none;
    transition: all 0.3s ease;
    text-align: center;
    font-family: Rajdhani;
    font-weight: 400;
    text-transform: uppercase;
    width: fit-content;
    &:hover {
      ${WMKGradient.grad()}
      color: white;
      border: 2px solid rgba(0, 0, 0, 0) !important;
      transition: all 0.3s ease;
    }
  }
`;
const IconsWrap = styled(Row)`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0 10vw;
  @media only screen and (max-width: 640px) {
    flex-direction: column;
    align-items: center;
  }
`;

const BlockTitleTextAndIconsRow = ({
  block,
}: {
  block: BlockTitleTextAndIconsRowFields;
}) => {
  const {
    headline,
    primaryCopy,
    secondaryCopy,
    icons,
    displayVersion,
    subtitle,
  } = block;

  return (
    <Wrap displayStyle={displayVersion}>
      {headline ? <h2>{headline}</h2> : null}
      {subtitle ? <p className="subtitle">{subtitle}</p> : <></>}
      {primaryCopy?.primaryCopy ? (
        <ReactMarkdown
          className={displayVersion === "White, left aligned" ? "subtitle" : ""}
          components={{
            a(props) {
              return (
                <WmkLink to={`${props.href}`} className="copyButton">
                  {props?.children}
                </WmkLink>
              );
            },
          }}
        >
          {primaryCopy.primaryCopy}
        </ReactMarkdown>
      ) : null}
      {displayVersion === "White, left aligned" ? (
        <Container>
          <Col>
            <Row className="light-display">
              {icons.map((iconSection) => {
                return (
                  <Col lg={4} md={6}>
                    <Row className="subsection-row">
                      <Col xs={3} sm={3} md={3} className="icon-col">
                        <WmkImage image={new Img(iconSection.icon)} />
                      </Col>
                      <Col>
                        <h6>{iconSection.header}</h6>
                        <p>{iconSection?.copy?.copy}</p>
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Container>
      ) : (
        <IconsWrap>
          {icons?.map((icon, i) => (
            <Col>
              <BlockIconCopy block={icon} key={`iconCopy-${i}`} />
            </Col>
          ))}
        </IconsWrap>
      )}
      {secondaryCopy?.secondaryCopy ? (
        <ReactMarkdown>{secondaryCopy.secondaryCopy}</ReactMarkdown>
      ) : null}
      {/* {block?.buttonLink?.slug ? (
        <Button to={block?.buttonLink?.slug} direction="right">
          {block?.buttonText}
        </Button>
      ) : (
        <></>
      )} */}
    </Wrap>
  );
};

export default BlockTitleTextAndIconsRow;
